<template>
  <div>
    <es-form>
      <template #es-form-header>
        <div class="header-container">
          <div class="header-elements">
            <font-awesome-icon :icon="['fas', 'poll']" size="lg" />
          </div>
          <div class="header-elements">
            <h6 class="title">
              Match Status
            </h6>
          </div>
        </div>
      </template>
      <template #es-form>
        <table class="table is-fullwidth">
          <thead>
            <th class="text-align--left has-text-grey"></th>
            <th class="text-align--left has-text-grey" title="Status">Status</th>
            <th class="text-align--left has-text-grey" title="Match Date">Match Date</th>
            <th class="text-align--right has-text-grey" title="Downloadable Record Count">Downloadable Record Count</th>
            <th class="text-align--right has-text-grey" title="Total Record Count">Total Record Count</th>
          </thead>
          <tbody v-if="dmobjmatch && categories.length" v-for="(category,index) in categories" :key="index">
              <tr v-if="item.groupCount >= 0" v-for="(item, itemindex) in category.data" :key="item.statType">
                <td class ="text-align--left">
                  <input type="radio" v-model="matchStatusOptions.matchStatusSelect" :value="item.statType">
                </td>
                <td class ="text-align--left">
                  {{ category.name }}
                  <!-- Need System Labels -->
                </td>
                <td class ="text-align--left">
                  {{ item.matchDate }}
                </td>
                <td class ="text-align--right">
                  {{ item.groupCount }}
                </td>
                <td class ="text-align--right">
                  {{ item.recordCount }}
                </td>
              </tr>
          </tbody>
        </table>
        <es-exception v-if="!categories.length" style="margin:2rem"
        exceptionMessage="No records are available for download."
        />
      </template>
    </es-form>
    <es-loader v-if="!dmobjmatch" />
  </div>
</template>
<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import moment from 'moment';
import { mapGetters } from 'vuex'

library.add(
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort
);

export default {
  components: {
    EsForm,
    EsHeader,
    EsFormActions,
    EsException,
    EsLoader,
  },
  mixins: [DateUtils],
  props:[
   'dmobjmatch',
   'matchStatusOptions',
   'categories',
  ],
 data() {
    return {
//      categories: [],
    };
  },
  mounted() {
  //  this.matchStatusOptions.matchStatusSelect = ( this.dmobjmatch.matchStats.length === 1 ) ? this.dmobjmatch.matchStats[0].statType : null;
//    this.groupedCategories();
  },
  methods: {
    downloadableStatus(statusType){
      //          const matches = [1,14,16].forEach(code => matchType[code] = 'Match / No Match (Completed)');
      //          const noMatches = [4,15].forEach(code => matchType[code] = 'Match / No Match (Completed)');
      //          const canceled = [13, 17].forEach(code => matchType[code] = 'Canceled (Completed)');
      //          const nearMatch = [2].forEach(code => matchType[code] = 'Ready to Resolve Near Matches (Pending)');

      var strVal = "" + statusType;
      const dlTypes = ["1", "2"];
      return dlTypes.includes(strVal);
    },
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    matchStatsLength() {
      if (this.dmobjmatch.matchStats) {
        console.log("matchStats length: " + this.dmobjmatch.matchStats.length);
        return this.dmobjmatch.matchStats.length;
      }
    },
  },
};
</script>

  <style lang="sass" scoped>
    .margin-bottom
      margin-bottom: 1rem
    .sort-by
      padding-right: 18px
      position: relative
      color: #777
      text-decoration: none
      &:before, &:after
      border: 4px solid transparent
      content: ""
      display: block
      height: 0
      right: 5px
      top: 50%
      position: absolute
      width: 0
      &:before
        border-bottom-color: #999
        margin-top: -9px
        &:after
          border-top-color: #999
          margin-top: 1px
    .header-container
      margin-bottom: 1rem
    .no-radius
      border-radius: 0
      background-color: #F2F2F2
      font-weight: normal
    .selected-option
      background-color: #ccc
      font-weight: bold
    .fields-container
      margin-left: 30px
    .text-align--left
      text-align: left !important
    .column-header
      padding-left: 0px
    .text-align--right
      text-align: right !important
    .text-align--left
      text-align: left !important
  </style>
